import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'loopCurrency',
  standalone: true,
})
export class CurrencyPipe implements PipeTransform {
  transform(value: number, forceDecimals: boolean = false, decimalPlaces: number = 2): string {
    if (value === null || value === undefined) {
      return '';
    }

    let formattedValue: string;

    if (forceDecimals) {
      formattedValue = value.toFixed(decimalPlaces).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      const hasDecimals = value % 1 !== 0;
      if (hasDecimals) {
        formattedValue = value.toFixed(decimalPlaces).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        formattedValue = value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    }

    return `£${formattedValue}`;
  }
}
